export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1000px] mx-auto text-center">
        <div className="flex items-center gap-3 mb-6 justify-center">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">联系我们</h2>
        </div>
        <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto mb-8">
          如遇到播放问题、资源失效或有任何建议，欢迎通过以下方式联系我们。777影院持续优化观影体验，你的反馈是我们进步的动力。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            onClick={(e) => e.preventDefault()}
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-background-800/60 hover:bg-background-800 border border-background-700/40 hover:border-accent-500/30 text-foreground-200 rounded-full transition-all text-sm cursor-pointer"
          >
            <i className="ri-mail-line text-lg"></i>
            投稿与合作
          </a>
          <a
            href="#contact"
            onClick={(e) => e.preventDefault()}
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-background-800/60 hover:bg-background-800 border border-background-700/40 hover:border-accent-500/30 text-foreground-200 rounded-full transition-all text-sm cursor-pointer"
          >
            <i className="ri-bug-line text-lg"></i>
            问题反馈
          </a>
          <a
            href="#contact"
            onClick={(e) => e.preventDefault()}
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full transition-all text-sm cursor-pointer"
          >
            <i className="ri-shake-hands-line text-lg"></i>
            商务合作
          </a>
        </div>
      </div>
    </section>
  );
}